import { Button } from '@simplywallst/ui-core/next';

import { pluralise } from '@/utilities/pluralise';

type Props = {
  onDelete: (rows: number[]) => void;
  onUnselect: () => void;
  selectedRows: number[];
};

export const RowDeleteMobile = ({
  selectedRows,
  onDelete,
  onUnselect,
}: Props) => {
  return (
    <div className="grid h-[64px] grid-cols-[minmax(auto,_768px)] items-center justify-center bg-surface-1">
      <div className="grid grid-cols-[max-content_max-content] items-center justify-between px-x2">
        <span className="text-pretty text-sm text-solid">
          {selectedRows.length} {pluralise(selectedRows.length, 'row', 'rows')}{' '}
          selected
        </span>
        <div className="grid grid-cols-2 gap-2">
          <Button variant="outline" onClick={onUnselect}>
            Unselect
          </Button>
          <button
            className="tw-reset border focus-outline relative inline-flex h-x5 select-none items-center justify-center gap-x0_5 rounded-md border-solid border-bad bg-bad px-x1_5 text-xs font-normal text-solid transition-[padding] hover:border-bad-subtle hover:bg-bad-strong"
            type="button"
            onClick={() => onDelete(selectedRows)}
          >
            Delete
          </button>
        </div>
      </div>
    </div>
  );
};
